import React from 'react';
import { SectionStack } from '@/components/ui/SectionStack';

import { ResponsivePicture } from '@/components/ResponsivePicture';
import mainSection1MobileImg from '@public/img/b2c/equity-release/main-section-1-mobile.webp';
import mainSection1TabImg from '@public/img/b2c/equity-release/main-section-1-tab.webp';
import mainSection1Img from '@public/img/b2c/equity-release/main-section-1.webp';
import mainSection2MobileImg from '@public/img/b2c/equity-release/main-section-2-mobile.webp';
import mainSection2TabImg from '@public/img/b2c/equity-release/main-section-2-tab.webp';
import mainSection2Img from '@public/img/b2c/equity-release/main-section-2.webp';
import mainSection3MobileImg from '@public/img/b2c/equity-release/main-section-3-mobile.webp';
import mainSection3TabImg from '@public/img/b2c/equity-release/main-section-3-tab.webp';
import mainSection3Img from '@public/img/b2c/equity-release/main-section-3.webp';
export const MainSection = () => (
  <SectionStack className="container mx-auto">
    <div className="lg:grid lg:grid-cols-[1fr,1fr] lg:gap-8 xl:gap-16 lg:items-center">
      {/* Left Column: Text Content */}
      <div className="order-2 lg:flex lg:items-center lg:h-full">
        <div>
          <h2 className="text-3xl md:text-4xl text-[#373945] font-semibold lg:pb-6 md:w-[35rem]">
            What is equity release?
          </h2>
          <p className="text-base text-[#373945] font-450 pb-6">
            Discover more about lifetime mortgages, what they can be used for, the things to be conscious of,
            whether you&#39;re eligible, and the alternative options available to later life borrowers.
          </p>
          <a href="/equity-release/what-is-equity-release">
            <p className="plain-text-link inline-flex items-center text-base text-[#006EB7] font-semibold gap-2 mb-8 lg:mb-0">
              View what is equity release
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                <path d="M3 9H15M15 9L10.5 4.5M15 9L10.5 13.5" stroke="#006EB7" strokeWidth="1.75" strokeLinecap="round"
                  strokeLinejoin="round"/>
              </svg>
            </p>
          </a>
        </div>
      </div>

      {/* Right Column: Image */}
      <div className="order-1 lg:flex lg:items-center">
        <ResponsivePicture
          mobile={mainSection1MobileImg}
          tablet={mainSection1TabImg}
          desktop={mainSection1Img}
          alt="Three people chatting around a table with mugs and a laptop"
          sizes="(min-width: 1024px) 50vw, 100vw"
          className="block rounded-xl w-full"
          pictureClassName="block w-full"
        />
      </div>
    </div>

    <div className="lg:grid lg:grid-cols-[1fr,1fr] lg:gap-8 xl:gap-16 lg:items-center">
      {/* Right Column: Text Content */}
      <div className="order-1 lg:flex lg:items-center lg:h-full">
        <div>
          <h2 className="text-3xl md:text-4xl text-[#373945] font-semibold lg:pb-6 md:w-[35rem]">
            How does equity release work?
          </h2>
          <p className="text-base text-[#373945] font-450 pb-6">
            Find out how a lifetime mortgage works, the things to consider, and whether it&#39;s the right choice for you,
            including an overview of a typical lifetime mortgage application journey.
          </p>
          <a href="/equity-release/how-does-equity-release-work">
            <p className="plain-text-link inline-flex items-center text-base text-[#006EB7] font-semibold gap-2 mb-8 lg:mb-0">
              View how does equity release work
              <svg className="mr-8" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                <path d="M3 9H15M15 9L10.5 4.5M15 9L10.5 13.5" stroke="#006EB7" strokeWidth="1.75" strokeLinecap="round"
                  strokeLinejoin="round"/>
              </svg>
            </p>
          </a>
        </div>
      </div>

      {/* Left Column: Image */}
      <div className="order-2 lg:flex lg:items-center">
        <ResponsivePicture
          mobile={mainSection2MobileImg}
          tablet={mainSection2TabImg}
          desktop={mainSection2Img}
          alt="Man writing notes in a notebook at a table with tea and a tablet"
          sizes="(min-width: 1024px) 50vw, 100vw"
          className="block rounded-xl w-full"
          pictureClassName="block w-full"
        />
      </div>
    </div>

    <div className="lg:grid lg:grid-cols-[1fr,1fr] lg:gap-8 xl:gap-16 lg:items-center">
      {/* Left Column: Text Content */}
      <div className="order-2 lg:flex lg:items-center lg:h-full">
        <div>
          <h2 className="text-3xl md:text-4xl text-[#373945] font-semibold lg:pb-6 md:w-[35rem]">
            Equity release glossary
          </h2>
          <p className="text-base text-[#373945] font-450 pb-6">
            Explore our glossary, providing an overview of equity release phrases and acronyms you may come
            across during your later life lending journey.
          </p>
          <a href="/equity-release/definitive-equity-release-glossary">
            <p className="plain-text-link inline-flex items-center text-base text-[#006EB7] font-semibold gap-2 mb-8 lg:mb-0">
              View equity release glossary
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                <path d="M3 9H15M15 9L10.5 4.5M15 9L10.5 13.5" stroke="#006EB7" strokeWidth="1.75" strokeLinecap="round"
                  strokeLinejoin="round"/>
              </svg>
            </p>
          </a>
        </div>
      </div>

      {/* Right Column: Image */}
      <div className="order-1 lg:flex lg:items-center">
        <ResponsivePicture
          mobile={mainSection3MobileImg}
          tablet={mainSection3TabImg}
          desktop={mainSection3Img}
          alt="Person reading a book"
          sizes="(min-width: 1024px) 50vw, 100vw"
          className="block rounded-xl w-full"
          pictureClassName="block w-full"
        />
      </div>
    </div>
  </SectionStack>
);
